import React from 'react';

import Button from 'components/common/Button/Button';
import { LogoIcon } from 'components/common/Icons/Icons';

import styles from './ErrorPage.module.scss';

const ErrorPage = () => {
  const handleOnClick = () => {
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <LogoIcon />
      </div>
      <div className={styles.contentContainer}>
        <h1 className={styles.title}>Something went wrong!</h1>
        <p className={styles.text}>We are really sorry :(</p>
        <Button className={styles.button} onClick={handleOnClick}>
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
